import { useCallback } from "react";
import Swal from "sweetalert2";
import { ProductType } from "../contexts/OrderContext";
import { useOrder } from "./useOrder";
import { useProduct } from "./useProduct";
import { usePluginspace } from "./usePluginspace";
import {
  ProductVisibilityCatalogItem,
  splitProductsByVisibilityHour,
} from "../utils/foodCartVisibilityHour";

export function useFoodCartVisibilityValidation() {
  const { getOrder, setProductsOrder } = useOrder();
  const { getProductsFood } = useProduct();
  const { getThisPluginspace } = usePluginspace();

  const validateAndCleanCart = useCallback(async (): Promise<boolean> => {
    try {
      const pgData = await getThisPluginspace();
      if (!pgData || pgData.type !== "food") {
        return true;
      }

      const order = await getOrder();
      const sentProducts = order.products.filter((product) => product.orderId);
      const cartProducts = order.products.filter(
        (product) => !product.orderId && product.quantity > 0
      );

      if (!cartProducts.length) {
        return true;
      }

      let catalog: ProductVisibilityCatalogItem[] = [];

      try {
        const productsFood = await getProductsFood(true);
        if (Array.isArray(productsFood)) {
          catalog = productsFood.map((product) => ({
            id: product.id,
            initialHour: product.initialHour ?? null,
            finalHour: product.finalHour ?? null,
          }));
        }
      } catch {
        catalog = [];
      }

      const { validProducts, removedProducts } = splitProductsByVisibilityHour(
        cartProducts,
        catalog
      );

      if (!removedProducts.length) {
        return true;
      }

      await setProductsOrder([...sentProducts, ...validProducts]);

      const productNames = removedProducts
        .map((product: ProductType) => product.name)
        .join(", ");

      await Swal.fire({
        icon: "warning",
        title: "Horário de venda encerrado",
        text: `Os seguintes produtos foram removidos do carrinho por estarem fora do horário disponível: ${productNames}.`,
        confirmButtonText: "Entendi",
      });

      return false;
    } catch (error) {
      console.log(error);
      return true;
    }
  }, [getOrder, getProductsFood, getThisPluginspace, setProductsOrder]);

  return { validateAndCleanCart };
}
